import { AllEntityStatusValues } from '@cbinsights/cbientityservice/cbientityservice';
import { request } from 'client/modules/common/utils/request';

export const getAllEntityStatusValues = (): Promise<AllEntityStatusValues> => {
  return request({
    url: '/service/cbientityservice/GetAllEntityStatusValues',
  }).then((r): AllEntityStatusValues => r.body);
};
